import { render, staticRenderFns } from "./StudentClassReports.vue?vue&type=template&id=ada37662&scoped=true&"
import script from "./StudentClassReports.vue?vue&type=script&lang=js&"
export * from "./StudentClassReports.vue?vue&type=script&lang=js&"
import style0 from "./StudentClassReports.vue?vue&type=style&index=0&id=ada37662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada37662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow})
